// extracted by mini-css-extract-plugin
export default {"container":"TableRow__container-saSzi","highlight":"TableRow__highlight-Li4qr"};